import { Component } from '@angular/core';
import { LeadService } from 'src/app/services/lead.service';

@Component({
  selector: 'upsc-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent {

  constructor(private leadService: LeadService) { }
  showState:number = 0;
  hideServiceInquiry: boolean = false;
  user: any = {
    cpi: 1,
    LastName: '',
    FirstName: '',
    CompanyName: '',
    Country: '',
    StateProvinceRegion: '',
    Zipcode: '',
    Email: '',
    PhoneNumber: '',
    HowCanWeHelp: '1',
    Referrer: 'https://upscapital.com/contact-ups-capital/',
    CampaignID: ''
  };

  onSubmit() {
    if (this.user.cpi == 1) {
      let FirstName = this.user.FirstName;
      let LastName = this.user.LastName;
      let CompanyName = this.user.CompanyName;
      let Country = this.user.Country;
      let HowCanWeHelp = this.user.HowCanWeHelp;
      let Zipcode = this.user.Zipcode;
      let PhoneNumber = this.user.PhoneNumber;
      let Email = this.user.Email;
      let emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      let phoneRegex = /^[\+]?[0-9]{1,4}[\s\.\-]?[0-9]{1,4}[\s\.\-]?[0-9]{1,4}[\s\.\-]?[0-9]{1,9}$/;

      if (emailRegex.test(Email) && FirstName && phoneRegex.test(PhoneNumber) && LastName && CompanyName && Country && HowCanWeHelp && Zipcode) {
        this.leadService.submitLead(this.user).subscribe(
          response => {
           // console.log('Lead submitted:', response);
            
            if(response.statuscode === 200)
            {
              this.user = {
                cpi: 1,
                LastName: '',
                FirstName: '',
                CompanyName: '',
                Country: '',
                StateProvinceRegion: '',
                Zipcode: '',
                Email: '',
                PhoneNumber: '',
                HowCanWeHelp: '1',
                Referrer: 'https://upscapital.com/contact-ups-capital/',
                CampaignID: ''
              };
              alert('Lead submitted successfully!');
            }
            else
            {
              alert('Something went wrong! Please try again');
            }
            
          },
          error => {
           // console.error('Error:', error);
            alert('Failed to submit lead.');
          }
        );
      }
      else if (!emailRegex.test(Email) && FirstName && phoneRegex.test(PhoneNumber) && LastName && CompanyName && Country && HowCanWeHelp && Zipcode) {
        alert('Please fill valid email ID');
      } else if (emailRegex.test(Email) && FirstName && !phoneRegex.test(PhoneNumber) && LastName && CompanyName && Country && HowCanWeHelp && Zipcode) {
        alert('Please fill valid phone number');
      }
      else {
        alert('Please fill in all fields!');
        return false;
      }

    }
  }


  toggleAccordion(el: string) {
    let accordionItemList = document.querySelectorAll('.accordion-collapse');
    accordionItemList.forEach(element => {
      if (element.id != el)
        element.classList.remove('collapsed');
    });
    let element = document.getElementById(el);
    element.classList.toggle('collapsed');
  }
  onCountryChange() {
    const restrictedCountries = ['CN', 'TH', 'HK'];
    this.hideServiceInquiry = restrictedCountries.includes(this.user.Country);

    if (this.hideServiceInquiry && this.user.HowCanWeHelp === '4') {
      this.user.HowCanWeHelp = '1';
    }

    // Hide all states
    document.querySelectorAll('.State-Options').forEach((el) => {
      (el as HTMLElement).style.display = 'none';
    });
   
    // Show states only for the selected country
    if (this.user.Country === 'US') {
      this.showState = 1;
      document.querySelectorAll('.US-State').forEach((el) => {
        (el as HTMLElement).style.display = 'block';
      });
    } else if (this.user.Country === 'MX') {
      this.showState = 1;
      document.querySelectorAll('.MX-State').forEach((el) => {
        (el as HTMLElement).style.display = 'block';
      });
    } else if (this.user.Country === 'CA') {
      this.showState = 1;
      document.querySelectorAll('.CA-State').forEach((el) => {
        (el as HTMLElement).style.display = 'block';
      });
    } else if (this.user.Country === 'TH') {
      this.showState = 1;
      document.querySelectorAll('.TH-State').forEach((el) => {
        (el as HTMLElement).style.display = 'block';
      });
    }
    else{
      this.showState = 0;
    }
  }
}